import {IconMoon, IconSun} from "@tabler/icons-react";
import {useThemeStore} from "../../store/useTheme.store";
import styles from "./ThemeToggle.module.css";

const ThemeToggle = () => {
  const theme = useThemeStore(state => state.theme);
  const toggleTheme = useThemeStore(state => state.toggleTheme);

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={toggleTheme}
      aria-label={isDark ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
      title={isDark ? "Modo claro" : "Modo oscuro"}
    >
      <span className={`${styles.iconWrapper} ${isDark ? styles.active : ""}`}>
        <IconMoon size={18} />
      </span>
      <span className={`${styles.iconWrapper} ${!isDark ? styles.active : ""}`}>
        <IconSun size={18} />
      </span>
      <span
        className={styles.slider}
        style={{transform: isDark ? "translateX(0)" : "translateX(100%)"}}
      />
    </button>
  );
};

export default ThemeToggle;
